import { isEvForeignTradeAnswered } from "../../searchFlowVersionB/steps/ev/EvForeignTrade.jsx";
import RegActivityDescription from "../steps/RegActivityDescription.jsx";
import RegForeignTrade from "../steps/RegForeignTrade.jsx";
import RegIndustryActivity from "../steps/RegIndustryActivity.jsx";
import RegIndustrySelect from "../steps/RegIndustrySelect.jsx";
import RegTaxForm, { isRegTaxFormSelectionValid } from "../steps/RegTaxForm.jsx";

const guardNextStep = (onNext, nextDisabled) => () => {
  if (nextDisabled) {
    return;
  }
  onNext?.();
};

const getIndustrySelectFooterNav = (self, onBack, onNext) => {
  const selectedIndustry = self.props.company_store?.industry || "";
  const industryInput = self.props.company_store?.industryinput || "";
  const isOtherSelected = selectedIndustry === "other";
  const nextDisabled =
    !selectedIndustry || (isOtherSelected && !String(industryInput).trim());

  return {
    onBack,
    onNext: guardNextStep(onNext, nextDisabled),
    nextDisabled,
  };
};

/** Footer config for the active RegFlow step — RegCompanyType/RegContactPage/RegSuccessScreen/GeneralError render their own nav. */
export const getRegStepFooterNav = (self, activeStep, steps) => {
  const stepComponent = steps[activeStep]?.component;
  if (!stepComponent) {
    return null;
  }

  if (stepComponent === RegIndustrySelect) {
    return getIndustrySelectFooterNav(
      self,
      // No back button on a direct landing — there's nowhere sensible to send it.
      self.state.cameFromNewCompanyType ? self.handleRegIndustrySelectBack : undefined,
      self.handleRegIndustrySelectNext,
    );
  }

  if (stepComponent === RegIndustryActivity) {
    return {
      onBack: self.handleRegIndustryActivityBack,
      onNext: self.handleRegIndustryActivityNext,
      nextDisabled: false,
    };
  }

  if (stepComponent === RegActivityDescription) {
    const nextDisabled = !String(self.props.company_store?.reqMessage || "").trim();
    return {
      onBack: self.handleRegActivityDescriptionBack,
      onNext: guardNextStep(self.handleRegActivityDescriptionNext, nextDisabled),
      nextDisabled,
    };
  }

  if (stepComponent === RegTaxForm) {
    const companytype = self.props.company_store?.companytype;
    const nextDisabled =
      !self.state.regTaxFormInteracted || !isRegTaxFormSelectionValid(companytype);
    return {
      onBack: self.handleRegTaxFormBack,
      onNext: guardNextStep(self.handleRegTaxFormNext, nextDisabled),
      nextDisabled,
    };
  }

  if (stepComponent === RegForeignTrade) {
    const { foreign_trade, foreigntradeEU } = self.props.company_store || {};
    const nextDisabled = !isEvForeignTradeAnswered(foreign_trade, foreigntradeEU);
    return {
      onBack: self.handleRegForeignTradeBack,
      onNext: guardNextStep(self.handleRegForeignTradeNext, nextDisabled),
      nextDisabled,
    };
  }

  return null;
};
